/* eslint-disable @typescript-eslint/member-ordering */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import * as fileSaver from 'file-saver';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';

@Component({
  selector: 'pdf-renderer',
  templateUrl: './pdf-renderer.component.html',
  styleUrls: ['./pdf-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PdfRendererComponent implements OnInit {
  @Input() pdfSrc: string;
  @Input() fileName: string;
  @ViewChild('pdfViewer', { read: ElementRef, static: true }) pdfViewer: ElementRef;
  public showSpinner: boolean = true;
  public page: number = 1;
  public zoom: number = 0.75;
  public pageReachedLast: boolean = false;
  public showAll: boolean = true;
  public stickToPage: boolean = true;
  @Output() pdfError: EventEmitter<any> = new EventEmitter();
  constructor(
    private toastService: HotToastService,
    public utilityService: UtilityService,
    private toast: HotToastService,
    private _dataCollectorService: DataCollectorService,
  ) {
  }

  ngOnInit(): void {
  }

  navigatePage(type: string): void {
    // this.showAll = false;
    // this.stickToPage = false;
    setTimeout(() => {
      this.page = type === 'increment' ? this.page + 1 : (type === 'decrement' && this.page > 1 ? this.page - 1 : this.page);
    }, 0);
    // setTimeout(() => {
    //   this.showAll = true;
    //   this.stickToPage = true;
    // }, 100);
  }

  changeZoomSize(type: string): void {
    this.zoom = type === '+' ? this.zoom + 0.25 : (type === '-' && this.zoom > 0.25 ? this.zoom - 0.25 : this.zoom);
  }

  setView(): void {
    this.showSpinner = false;
  }

  downloadPdf(): void {
    const loader = this.toast.loading(this.utilityService.getLocaleValue('toast.prepare_to_download','Preparing to download'));
    this._dataCollectorService.downloadData(this.pdfSrc, { responseType: 'blob', observe: 'response' }).subscribe((response: any)=>{
      loader.close();
      fileSaver.saveAs(response.body, this.fileName);
    },(_error: any)=>{
      loader.close();
    });
  }

  unableToLoadPdf(): void {
    this.showSpinner = false;
    this.toastService.error(`${this.utilityService.getLocaleValue('text.unable_to_load', 'Unable to load')}
    ${this.fileName ??  this.utilityService.getLocaleValue('text.untitled_file', 'Untitled File')}`);
    this.pdfError.emit({
      isError: true,
    });
  }

}
